import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=252b7e36&scoped=true&"
import script from "./dataStatistics.vue?vue&type=script&lang=js&"
export * from "./dataStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252b7e36",
  null
  
)

export default component.exports